import { useState } from "react";     
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const DateRangeFilter = ({setFilters ,filters}) => {
 
    

const handleDateRange =(update)=>{
    const [startDate, endDate] = update;
setFilters((prev)=>({
...prev,
from:startDate,to:endDate
}))
}
  return (
    <div className="add col-3">
         <DatePicker selectsRange selected={filters.from}   onChange={(update) => handleDateRange(update)}   startDate={filters.from}
        endDate={filters.to}  className="form-control"   isClearable    placeholderText="اختر المدة"/>
    </div>   
  )
}

export default DateRangeFilter